import React from 'react';
import { Link } from 'react-router-dom';
import { AwardIcon, GraduationCapIcon, CheckCircleIcon } from 'lucide-react';
export function Leadership() {
  return <section id="leadership" className="py-24 bg-white" data-id="element-137">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        <div className="text-center mb-16" data-id="element-139">
          <h2 className="text-brand-red font-bold tracking-wider uppercase text-sm mb-4" data-id="element-140">
            Leadership
          </h2>
          <h3 className="text-3xl lg:text-4xl font-bold text-brand-navy" data-id="element-141">
            Expert Care You Can Trust
          </h3>
        </div>

        <div className="grid lg:grid-cols-2 gap-12" data-id="element-142">
          {/* Founder */}
          <div className="bg-brand-light rounded-3xl p-8 lg:p-12 border border-gray-100" data-id="element-143">
            <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-144">
              <div className="w-32 h-32 rounded-2xl bg-brand-navy flex items-center justify-center flex-shrink-0" data-id="element-145">
                <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?auto=format&fit=crop&q=80&w=300" alt="Founder" className="w-full h-full object-cover rounded-2xl opacity-90" data-id="element-146" />
              </div>
              <div data-id="element-147">
                <h4 className="text-2xl font-bold text-brand-navy" data-id="element-148">
                  Founder & Clinical Director
                </h4>
                <p className="text-brand-red font-semibold mb-4" data-id="element-149">
                  Nurse Practitioner (15+ Years Exp.)
                </p>
                <p className="text-gray-600 mb-6" data-id="element-150">
                  Expertise in family practice, critical care support, and
                  chronic disease management within private and government
                  systems.
                </p>
                <div className="space-y-2" data-id="element-151">
                  {['Family Practice & Primary Care', 'Critical Care Support', 'Chronic Disease Management', 'Health Risk Assessments'].map(skill => <div key={skill} className="flex items-center text-sm font-medium text-brand-navy" data-id="element-152">
                      <CheckCircleIcon className="h-4 w-4 text-brand-red mr-2" data-id="element-153" />
                      {skill}
                    </div>)}
                </div>
              </div>
            </div>
          </div>

          {/* Co-Founder */}
          <div className="bg-brand-navy rounded-3xl p-8 lg:p-12 text-white" data-id="element-154">
            <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-155">
              <div className="w-32 h-32 rounded-2xl bg-white/10 flex items-center justify-center flex-shrink-0" data-id="element-156">
                <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=300" alt="Co-Founder" className="w-full h-full object-cover rounded-2xl opacity-90" data-id="element-157" />
              </div>
              <div data-id="element-158">
                <h4 className="text-2xl font-bold" data-id="element-159">
                  Co-Founder & Mental Wellness Director
                </h4>
                <p className="text-brand-red font-semibold mb-4" data-id="element-160">
                  Board-Certified Master Mental Health Coach
                </p>
                <p className="text-gray-300 mb-6" data-id="element-161">
                  Specializing in marriage restoration, trauma recovery, and
                  emotional healing with over 13 years of leadership expertise.
                </p>
                <div className="space-y-2" data-id="element-162">
                  {['Marriage & Relationship Restoration', 'Trauma Recovery & Emotional Healing', 'Grief & Loss Support', 'Life Recovery Coaching'].map(skill => <div key={skill} className="flex items-center text-sm font-medium text-white/90" data-id="element-163">
                      <CheckCircleIcon className="h-4 w-4 text-brand-red mr-2" data-id="element-164" />
                      {skill}
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-165">
          <Link to="/leadership" className="inline-flex items-center text-brand-navy font-bold hover:text-brand-red transition-colors group" data-id="element-166">
            Read More About Our Leadership
            <GraduationCapIcon className="ml-2 h-5 w-5" data-id="element-167" />
          </Link>
        </div>
      </div>
    </section>;
}